import { useCallback } from 'react';
import customise from '../../constants/customise';
import { ScrollInViewBehaviourType, ScrollInViewType, scrollInView, } from '../../index';
export default function useScrollToSection() {
    const scrollToSection = useCallback((selector, scrollBehaviour, scrollInViewType) => {
        if (document) {
            const sectionToScrollTo = document.querySelector(selector) ??
                document.getElementById(selector);
            if (sectionToScrollTo) {
                scrollInView.scrollInView(sectionToScrollTo, scrollInViewType ?? ScrollInViewType.TOP, scrollBehaviour ?? ScrollInViewBehaviourType.AUTO);
            }
        }
    }, []);
    const scrollToDisclaimer = useCallback((e) => {
        e.stopPropagation();
        scrollToSection(customise.DISCLAIMER, ScrollInViewBehaviourType.SMOOTH);
    }, [scrollToSection]);
    return { scrollToSection, scrollToDisclaimer };
}
//# sourceMappingURL=useScrollToSection.js.map